var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46033 15.2229C7.37142 15.2229 8.92066 16.7497 8.92066 18.6115C8.92066 20.4733 7.37142 22 5.46033 22C3.54924 22 2 20.4733 2 18.6115C2 16.7497 3.54924 15.2229 5.46033 15.2229Z",
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46033 2C7.37142 2 8.92066 3.52672 8.92066 5.38853C8.92066 7.25035 7.37142 8.77706 5.46033 8.77706C3.54924 8.77706 2 7.25035 2 5.38853C2 3.52672 3.54924 2 5.46033 2Z",
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5397 15.2229C20.4508 15.2229 22 16.7497 22 18.6115C22 20.4733 20.4508 22 18.5397 22C16.6286 22 15.0793 20.4733 15.0793 18.6115C15.0793 16.7497 16.6286 15.2229 18.5397 15.2229Z",
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5397 2C20.4508 2 22 3.52672 22 5.38853C22 7.25035 20.4508 8.77706 18.5397 8.77706C16.6286 8.77706 15.0793 7.25035 15.0793 5.38853C15.0793 3.52672 16.6286 2 18.5397 2Z",
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsOn);
export default __webpack_public_path__ + "static/media/dots_on.163f4fca70c76e3d89a9f8dbfe3c4e26.svg";
export { ForwardRef as ReactComponent };